/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdminCompanyCourseInviteCourseDto
 */
export interface AdminCompanyCourseInviteCourseDto {
  /**
   *
   * @type {string}
   * @memberof AdminCompanyCourseInviteCourseDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AdminCompanyCourseInviteCourseDto
   */
  name: string;
}

export function AdminCompanyCourseInviteCourseDtoFromJSON(json: any): AdminCompanyCourseInviteCourseDto {
  return AdminCompanyCourseInviteCourseDtoFromJSONTyped(json, false);
}

export function AdminCompanyCourseInviteCourseDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AdminCompanyCourseInviteCourseDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function AdminCompanyCourseInviteCourseDtoToJSON(value?: AdminCompanyCourseInviteCourseDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
